import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { Box } from '@mui/material';
import classnames from 'classnames';

import AdminSupplementStatusDot from '@components/AdminSupplementStatusDot/AdminSupplementStatusDot';
import { adminSupplementDetailsSelector } from '@store/features/adminInquiries/supplementDetails/selectors';
import useOrganizationById from '@store/hooks/useOrganizationById';
import formatDate from '@utils/formatDate';
import formatTime from '@utils/formatTime';
import getShortenText from '@utils/getShortenText';

import { IDetailsAtTopProps } from './DetailsAtTop.interface';

import './style.scss';

const DetailsAtTop: FC<IDetailsAtTopProps> = ({ className }) => {
  const { t } = useTranslation();

  const adminSupplementInquiryDetails = useSelector(adminSupplementDetailsSelector);
  const organization = useOrganizationById(adminSupplementInquiryDetails?.organizationId);

  return (
    <Box className={classnames('admin-supplement-inquiry-details-top', className)}>
      <Box className="admin-supplement-inquiry-details-top__base-info">
        <Box className="admin-supplement-inquiry-details-top__row">
          {adminSupplementInquiryDetails && (
            <AdminSupplementStatusDot
              className="admin-supplement-inquiry-details-top__status"
              value={adminSupplementInquiryDetails.adminSupplementInquiryStatusId}
            />
          )}
          <Box className="admin-supplement-inquiry-details-top__id">
            <div className="admin-supplement-inquiry-details-top__header">ID #</div>
            <div className="admin-supplement-inquiry-details-top__value">
              {adminSupplementInquiryDetails?.supplementInquiryId}
            </div>
          </Box>
          <Box className="admin-supplement-inquiry-details-top__submitted">
            <div className="admin-supplement-inquiry-details-top__header">
              {t('adminInquiries.submitted')}
            </div>
            <div className="admin-supplement-inquiry-details-top__value">
              {adminSupplementInquiryDetails &&
                formatTime(adminSupplementInquiryDetails.submittedOn)}{' '}
              •{' '}
              {adminSupplementInquiryDetails &&
                formatDate(adminSupplementInquiryDetails.submittedOn)}
            </div>
          </Box>
          <Box className="admin-supplement-inquiry-details-top__org">
            <div className="admin-supplement-inquiry-details-top__header">
              {t('adminInquiries.org')}
            </div>
            <div className="admin-supplement-inquiry-details-top__value">
              {getShortenText(organization?.name)}
            </div>
          </Box>
        </Box>
        <Box className="admin-supplement-inquiry-details-top__row">
          <Box className="admin-supplement-inquiry-details-top__updated-by">
            <div className="admin-supplement-inquiry-details-top__header">
              {t('adminInquiries.lastUpdatedBy')}
            </div>
            <div className="admin-supplement-inquiry-details-top__value">
              {adminSupplementInquiryDetails?.lastUpdatedBy || '-'}
            </div>
          </Box>
          <Box className="admin-supplement-inquiry-details-top__updated">
            <div className="admin-supplement-inquiry-details-top__header">
              {t('adminInquiries.lastUpdated')}
            </div>
            <div className="admin-supplement-inquiry-details-top__value">
              {(adminSupplementInquiryDetails?.lastUpdatedOn &&
                formatDate(adminSupplementInquiryDetails.lastUpdatedOn)) ||
                '-'}
            </div>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default DetailsAtTop;
